import React from 'react';
import Icon from 'components/AppIcon';
import { supabase } from '../../../lib/supabase';

const NOTIF_STYLES = {
  WAR_DECLARED: { icon: 'Swords', color: 'text-red-400', bg: 'bg-red-500/10', border: 'border-red-500/20' },
  VAULT_LOW: { icon: 'AlertTriangle', color: 'text-orange-400', bg: 'bg-orange-500/10', border: 'border-orange-500/20' },
  MEMBER_REQUEST: { icon: 'UserPlus', color: 'text-blue-400', bg: 'bg-blue-500/10', border: 'border-blue-500/20' },
  TERRITORY_LOST: { icon: 'Flag', color: 'text-purple-400', bg: 'bg-purple-500/10', border: 'border-purple-500/20' },
};

const NotificationPanel = ({ notifications, onMarkRead }) => {
  const unread = notifications?.filter((n) => !n?.read_at)?.length || 0;

  const handleMarkRead = async (id) => {
    try {
      await supabase?.rpc('mark_notification_read', { p_notification_id: id });
      onMarkRead?.(id);
    } catch (err) {
      console.error('Failed to mark notification read:', err?.message);
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 border-b border-border">
        <div className="flex items-center gap-2">
          <Icon name="Bell" size={14} className="text-primary" />
          <span className="text-sm font-semibold text-foreground">Leader Notifications</span>
        </div>
        {unread > 0 && (
          <span className="text-xs px-2 py-0.5 rounded-full bg-primary/20 text-primary font-medium">
            {unread} new
          </span>
        )}
      </div>
      <div className="max-h-64 overflow-y-auto">
        {notifications?.length === 0 ? (
          <div className="p-4 text-center">
            <Icon name="BellOff" size={24} className="text-muted-foreground mx-auto mb-2" />
            <p className="text-xs text-muted-foreground">No notifications</p>
          </div>
        ) : (
          <div className="divide-y divide-border/30">
            {notifications?.map((notif) => {
              const style = NOTIF_STYLES?.[notif?.notification_type] || {
                icon: 'Bell',
                color: 'text-muted-foreground',
                bg: 'bg-muted',
                border: 'border-border',
              };
              return (
                <div
                  key={notif?.id}
                  className={`flex items-start gap-3 p-3 transition-colors ${
                    !notif?.read_at ? `${style?.bg}` : 'opacity-60'
                  }`}
                >
                  <div
                    className={`w-7 h-7 rounded-md flex items-center justify-center flex-shrink-0 ${style?.bg} border ${style?.border}`}
                  >
                    <Icon name={style?.icon} size={13} className={style?.color} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-xs font-semibold text-foreground">{notif?.title}</p>
                    <p className="text-xs text-muted-foreground mt-0.5">{notif?.body}</p>
                    <p className="text-xs text-muted-foreground mt-1">
                      {notif?.created_at
                        ? new Date(notif.created_at)?.toLocaleTimeString([], {
                            hour: '2-digit',
                            minute: '2-digit',
                          })
                        : ''}
                    </p>
                  </div>
                  {!notif?.read_at && (
                    <button
                      onClick={() => handleMarkRead(notif?.id)}
                      className="flex-shrink-0 w-2 h-2 rounded-full bg-primary mt-1 hover:bg-primary/70 transition-colors"
                      title="Mark as read"
                    />
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationPanel;
